export const API_BASE_URL = process.env.REACT_APP_API_URL;

export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || 'your_google_client_id_here.apps.googleusercontent.com';

export const TOKEN_KEYS = {
  ACCESS: 'visaco_access_token',
  REFRESH: 'visaco_refresh_token',
};
